/**
 * 生涯卡测试 答题和报告的路由
 */

import {
  loadPageFail
} from '../lib/units';

export default [
  {
    name: 'careerCardAnswer',
    path: '/careercard-answer',
    meta: {
      title: '答题初始化页面'
    },
    component: resolve => require(['../pages/careerCard/answer.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '生涯卡答题页',
        err
      })
    }),
  },
  {
    name: 'careerCardReport',
    path: '/careercard-report',
    meta: {
      title: '人生卡牌'
    },
    component: resolve => require(['../pages/careerCard/report.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '人生卡牌',
        err
      })
    }),
  },
  {
    name: 'careerCardShare',
    path: '/careercard-share',
    meta: {
      title: '人生卡牌'
    },
    component: resolve => require(['../pages/careerCard/reportShare.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '人生卡牌',
        err
      })
    }),
  }
]



// WEBPACK FOOTER //
// ./src/router/careerCard.js